/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../types/graph';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetBasicsQueryVariables = SchemaTypes.Exact<{ [key: string]: never; }>;


export type GetBasicsQuery = { __typename?: 'Query', surveyBasics: { __typename?: 'Basics', gender: SchemaTypes.Gender | null, dateOfBirth: string | null, stateId: number | null, id: string }, currentUser: { __typename?: 'User', id: string, email: string | null, firstName: string | null }, surveyOccupation: { __typename?: 'Occupation', id: string, annualIncomeBeforeCompany: number | null, atLeast30HoursAWeek: boolean | null, becameOwnerAt: string | null, companyFoundedAt: string | null, corporateStructure: string | null, disabilityInsuranceSource: string | null, disabilityInsuranceStatus: boolean | null, educationLevel: string | null, employerPaysPremium: boolean | null, existingCoverage: number | null, governmentEmployee: boolean | null, individualIncome: number | null, intendToReplace: boolean | null, numberOfEmployees: number | null, numberOfPartners: number | null, ownershipStake: number | null, selfEmployed: boolean | null, workFromHomePercentage: number | null, yearsOfExperience: number | null, job: { __typename?: 'Job', id: string, title: string, group: string } | null } };


export const GetBasicsDocument = gql`
    query GetBasics {
  surveyBasics {
    gender
    dateOfBirth
    stateId
    id
  }
  currentUser {
    id
    email
    firstName
  }
  surveyOccupation {
    id
    annualIncomeBeforeCompany
    atLeast30HoursAWeek
    becameOwnerAt
    companyFoundedAt
    corporateStructure
    disabilityInsuranceSource
    disabilityInsuranceStatus
    educationLevel
    employerPaysPremium
    existingCoverage
    governmentEmployee
    individualIncome
    intendToReplace
    job {
      id
      title
      group
    }
    numberOfEmployees
    numberOfPartners
    ownershipStake
    selfEmployed
    workFromHomePercentage
    yearsOfExperience
  }
}
    `;
export function useGetBasicsQuery(baseOptions?: Apollo.QueryHookOptions<GetBasicsQuery, GetBasicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBasicsQuery, GetBasicsQueryVariables>(GetBasicsDocument, options);
      }
export function useGetBasicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBasicsQuery, GetBasicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBasicsQuery, GetBasicsQueryVariables>(GetBasicsDocument, options);
        }
export function useGetBasicsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBasicsQuery, GetBasicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBasicsQuery, GetBasicsQueryVariables>(GetBasicsDocument, options);
        }
export type GetBasicsQueryHookResult = ReturnType<typeof useGetBasicsQuery>;
export type GetBasicsLazyQueryHookResult = ReturnType<typeof useGetBasicsLazyQuery>;
export type GetBasicsSuspenseQueryHookResult = ReturnType<typeof useGetBasicsSuspenseQuery>;
export type GetBasicsQueryResult = Apollo.QueryResult<GetBasicsQuery, GetBasicsQueryVariables>;